package com.arena_web.ui.localization

object AppStringsEN : AppStrings {

    // language selector
    override val headerProfileLanguage = "Language"
    override val headerProfileLanguageRecommended = "Recommended"

    // common
    override val commonSeeAll = "See all"
    override val commonNo = "No"
    override val commonYes = "Yes"
    override val commonConfirm = "Confirm"
    override val commonSend = "Send"
    override val commonError = "Error"
    override val commonOk = "OK"

    // chat
    override val chatMenuUnmute = "Unmute"
    override val chatMenuMute = "Mute"
    override val chatMenuInviteMembers = "Invite Members"
    override val chatMenuLeaveGroup = "Leave Group"
    override val chatMenuDeleteChat = "Delete Chat"
    override fun chatRemoveMemberTitle(name: String) = "Remove $name?"
    override fun chatRemoveMemberWarning(name: String) = "Remove $name from the group? This action cannot be undone."
    override val chatRemoveMemberAction = "Remove"
    override val chatDefaultName = "Chat"
    override fun chatTypingOne(name: String) = "$name is typing..."
    override fun chatTypingMany(count: Int) = "$count people typing..."
    override fun chatMembersCount(count: Int) = "$count members"
    override fun chatMembersCountOnline(count: Int, online: Int) = "$count members, $online online"
    override val chatOnline = "Online"
    override val chatOffline = "Offline"
    override val chatEditCommunityTitle = "Edit Community"
    override val chatCommunityNameLabel = "Community Name"
    override val chatCommunityNamePlaceholder = "Enter community name..."
    override val chatSaving = "Saving..."
    override val chatMessageInputPlaceholder = "Type a message..."
    override val chatInviteMembersTitle = "Invite members"
    override val chatSearchFriendsPlaceholder = "Search friends..."
    override val chatNoFriendsToInvite = "No friends to invite"
    override val chatNoResults = "No results"
    override val chatInviting = "Inviting..."
    override val chatInvite = "Invite"
    override fun chatInviteCount(count: Int) = "Invite ($count)"
    override val chatPanelTitle = "Arena Chat"
    override val chatSearchPlaceholder = "Search chat"
    override val chatFilterAll = "All"
    override val chatFilterDirect = "Direct"
    override val chatFilterCommunity = "Community"
    override val chatNoChatsFound = "No chats found"
    override val chatNoConversationsYet = "No conversations yet"
    override val chatNewChatTitle = "New Chat"
    override val chatTabDirectMessage = "Direct Message"
    override val chatTabCommunity = "Community"
    override val chatSearchPeoplePlaceholder = "Search people you follow..."
    override val chatNotFollowingAnyone = "You aren't following anyone yet"
    override val chatCreating = "Creating..."
    override val chatCreateCommunity = "Create Community"
    override val chatSelectConversation = "Select a conversation"
    override fun chatReplyTo(name: String) = "Reply to $name"
    override val chatUnknownSender = "Unknown"
    override val chatUploading = "Uploading..."
    override val chatEditingMessage = "Editing message"
    override val chatSearchInChatPlaceholder = "Search in chat..."
    override fun chatSearchResultsFound(count: Int) = "$count found"
    override val chatGroupInfoTitle = "Group Info"
    override val chatUserInfoTitle = "User Info"
    override val chatDeleteChatAction = "Delete chat"
    override val chatDeleteGroupAction = "Delete group"
    override val chatLeaveGroupAction = "Leave group"
    override val chatLastSeenRecently = "last seen recently"
    override val chatNotificationsLabel = "Notifications"
    override val chatTabMembers = "Members"
    override val chatTabMedia = "Media"
    override val chatTabFiles = "Files"
    override val chatTabLinks = "Links"
    override val chatLoading = "Loading..."
    override val chatNoMediaYet = "No media yet"
    override val chatNoFilesYet = "No files yet"
    override val chatUnknownFile = "Unknown file"
    override val chatNoLinksYet = "No links yet"
    override val chatNoMembers = "No members"
    override val chatRoleOwner = "Owner"
    override val chatRoleAdmin = "Admin"
    override val chatEdited = "edited"
    override val chatFileFallback = "File"
    override val chatMenuReply = "Reply"
    override val chatMenuPin = "Pin"
    override val chatEmptyTitle = "No Chats Yet"
    override val chatEmptySubtitle = "Start a conversation to see your messages here."
    override val chatUnnamed = "Unnamed"
    override val chatNoMessagesYet = "No messages yet"
    override val chatRoomEmptyTitle = "No Messages Yet"
    override val chatRoomEmptySubtitle = "Say hi to start the conversation."
    override fun chatMembersHeader(count: Int) = "Members ($count)"
    override val chatNoMediaSharedYet = "No media shared yet"
    override val chatNoFilesSharedYet = "No files shared yet"
    override val chatNoLinksSharedYet = "No links shared yet"

    // widget
    override val widgetDismiss = "Dismiss"
    override val widgetSomethingWentWrong = "Something went wrong"
    override val widgetTryAgain = "Try Again"
    override val widgetCookieTitle = "We use cookies"
    override val widgetCookieMessage = "This website uses cookies to ensure you get the best experience."
    override val widgetCookieDecline = "Decline"
    override val widgetCookieAccept = "Accept"
    override val widgetAddInterval = "Add Interval"
    override val widgetSendMessage = "Send Message"
    override val widgetPrevious = "Previous"
    override val widgetStatusVip = "VIP"
    override val widgetStatusActive = "Active"
    override val widgetStatusDebtor = "Debtor"
    override val widgetStatusInactive = "Inactive"
    override val widgetUnpaid = "unpaid"
    override val widgetStatusInProgress = "In Progress"
    override val widgetStatusUpcoming = "Upcoming"
    override val widgetStatusPending = "Pending"
    override val widgetStatusCompleted = "Completed"
    override fun widgetFieldLabel(number: String) = "Field $number"
    override val widgetYearly = "Yearly"
    override val widgetAllFields = "All fields"
    override val widgetPreviousMonth = "Previous month"
    override val widgetNextMonth = "Next month"
    override val widgetSortAscending = "Sort ascending"
    override val widgetSortDescending = "Sort descending"
    override val widgetChecked = "Checked"

    // form
    override val formSelectPlaceholder = "Select..."

    // common
    override val commonCancel = "Cancel"
    override val commonSave = "Save"
    override val commonDelete = "Delete"
    override val commonEdit = "Edit"
    override val commonNext = "Next"
    override val commonRetry = "Retry"
    override val commonSearch = "Search"

    // event
    override val eventMatchEndedTitle = "THE MATCH ENDED"
    override val eventMatchEndedSubtitle = "Rate players to update their personal rankings."
    override val eventTabMatchInfo = "Match Info"
    override val eventTabLineups = "Lineups"
    override val eventTabMedia = "Media"
    override val eventCreateTeam = "Create Team"
    override val eventCancelEventQuestion = "Cancel event?"
    override val eventDeleteEventQuestion = "Delete event?"
    override fun eventWillBeCancelled(eventTitle: String) = "\"$eventTitle\" will be marked as cancelled."
    override fun eventWillBeDeleted(eventTitle: String) = "\"$eventTitle\" will be permanently deleted."
    override val eventCancelNoticeParticipants = "Other participants will be notified. Chat and history stay available."
    override val eventDeleteNoticeMedia = "Event image and chat will be removed too."
    override val eventKeepEvent = "Keep event"
    override val eventCancelling = "Cancelling..."
    override val eventDeleting = "Deleting..."
    override val eventCancelEvent = "Cancel event"
    override val eventMatchPerformanceTitle = "Match Performance"
    override val eventProPlusLabel = "Pro⁺"
    override val eventStatLabel = "Stat"
    override val eventProPlusStatDescription = "Detailed shots accuracy, pass completion and ball possession."
    override val eventLoadingMedia = "Loading media..."
    override val eventDeleteMediaQuestion = "Delete media?"
    override val eventDeleteMediaMessage = "This file will be removed from the event for everyone."
    override val eventNoMediaYet = "No media yet"
    override val eventNoMediaDescription = "Photos and videos from this match will appear here."
    override val eventInviteTeamTitle = "Invite Team"
    override val eventSearchTeamsLabel = "Search Teams"
    override val eventSearchTeamsPlaceholder = "Enter team name..."
    override val eventSearching = "Searching..."
    override val eventNoTeamsFound = "No teams found"
    override fun eventTeamRating(rating: String) = "$rating rating"
    override fun eventTeamMembersCount(count: Int) = "$count members"
    override val eventInviteStatusAccepted = "Accepted"
    override val eventInviteStatusDeclined = "Declined"
    override val eventInviteStatusInvited = "Invited"
    override val eventInvite = "Invite"
    override val eventStartEventQuestion = "Start event?"
    override fun eventWillGoLive(eventTitle: String) = "\"$eventTitle\" will go live."
    override val eventStartNotice = "Registration will close and the match will begin."
    override fun eventPendingRequestOne(count: Int) = "$count pending request"
    override fun eventPendingRequestsMany(count: Int) = "$count pending requests"
    override val eventPendingRequestsSubtitle = "These players asked to join but haven't been approved yet."
    override fun eventPlayersWithoutTeamOne(count: Int) = "$count player without a team"
    override fun eventPlayersWithoutTeamMany(count: Int) = "$count players without a team"
    override val eventTeamlessSubtitle = "They're confirmed but not assigned to any squad."
    override val eventStarting = "Starting..."
    override val eventStartAnyway = "Start anyway"
    override val eventMonthJanuary = "January"
    override val eventMonthFebruary = "February"
    override val eventMonthMarch = "March"
    override val eventMonthApril = "April"
    override val eventMonthMay = "May"
    override val eventMonthJune = "June"
    override val eventMonthJuly = "July"
    override val eventMonthAugust = "August"
    override val eventMonthSeptember = "September"
    override val eventMonthOctober = "October"
    override val eventMonthNovember = "November"
    override val eventMonthDecember = "December"
    override val eventVs = "vs"
    override val eventTeamsLabel = "teams"
    override val eventPlayersLabel = "players"
    override val eventProBadge = "PRO"
    override val eventCompletedBadge = "Completed"
    override val eventLeadersEmptyWinGame = "Win a game to climb the leaderboard."
    override val eventLeadersEmptyFirstScore = "Be the first to score and top the leaderboard."
    override val eventLeadersEmptyTakeSet = "Take a set to claim the top spot."
    override val eventLeadersEmptyFirstAssist = "Be the first one to deliver a match-winning pass."
    override fun eventTopStat(name: String) = "Top $name"
    override val eventPlayerFallback = "Player"
    override val eventCreateTeamSubtitle = "Set up your squad for the match"
    override val eventTeamNameLabel = "Team Name"
    override val eventTeamNameRequired = "Team name is required"
    override val eventTeamColorLabel = "Team Color"
    override val eventTeamColorSubtitle = "Choose your team's color"
    override val eventTeamNamePlaceholder = "Enter team name..."
    override val eventChatTitle = "Chat"
    override val eventChatLive = "Live"
    override val eventChatPlayersLabel = "Players"
    override val eventChatWaitingApproval = "Waiting for approval"
    override val eventChatConfirmingSpot = "Confirming your spot"
    override val eventChatLocked = "Chat is Locked"
    override val eventChatWaitingApprovalSubtitle = "Once the admin confirms your request you'll be able to chat with the team."
    override val eventChatConfirmingSpotSubtitle = "Your join request is being processed. Chat unlocks the moment you're in."
    override val eventChatPrivateSubtitle = "This is a private event. Request to join and wait for the admin to approve."
    override val eventChatLockedSubtitle = "You must join this match to see the conversation and talk with other players."
    override val eventJoinEvent = "Join Event"
    override val eventChatNoMessages = "No messages yet"
    override val eventChatNoMessagesSubtitle = "Start the conversation with your team."
    override val eventTeamSectionTitle = "Team"
    override val eventDeleteTeam = "Delete Team"
    override val eventViewProfile = "View Profile"
    override val eventRemoveAdmin = "Remove Admin"
    override val eventMakeAdmin = "Make Admin"
    override val eventRemoveFromTeam = "Remove from Team"
    override val eventRemoveFromEvent = "Remove from Event"
    override fun eventFormatVs(format: Int) = "$format vs $format"
    override fun eventTeamsCount(count: Int) = "$count teams"
    override fun eventPlayersOfMax(joined: Int, max: Int) = "$joined / $max players"
    override fun eventPlayersCount(count: Int) = "$count players"
    override val eventStatusLive = "Live"
    override val eventLeave = "Leave"
    override val eventStart = "Start"
    override val eventJoin = "Join"
    override val eventStatusPending = "Pending"
    override val eventStatusCanceled = "Canceled"
    override val eventPendingApprovalBadge = "Pending approval"
    override val eventRatePerformanceTitle = "Rate Performance"
    override val eventRateVoteCounts = "Your vote counts !"
    override val eventCommunityRating = "Community Rating"
    override val eventSubmitRating = "Submit Rating"
    override val eventSubmitting = "Submitting..."
    override val eventAddMediaTitle = "Add Media"
    override val eventUploadMedia = "Upload Media"
    override val eventDropMediaHere = "Drop your photo and video here"
    override val eventMaxFileSize = "max 30 MB"
    override val eventSelectedLabel = "Selected"
    override val eventClearAll = "Clear all"
    override val eventAddToTeam = "Add to Team"
    override val eventMakeSubstitution = "Make substitution"
    override val eventViewProfileSheet = "View profile"
    override fun eventSwapWith(name: String) = "Swap $name with"
    override val eventEndMatch = "End match"
    override val eventReset = "Reset"
    override val eventLeadersEmptyWinGameShort = "Win a game to climb the leaderboard"
    override val eventLeadersEmptyScoreFirst = "Score first to top the leaderboard"
    override val eventLeadersEmptyTakeSetShort = "Take a set to claim the top spot"
    override val eventLeadersEmptyWinningAssist = "Make the Winning Assist"
    override val eventRatePlayersSubtitle = "Rate players to update Top Rankings"
    override val eventGenericError = "Something went wrong"
    override val eventDeleteTeamQuestion = "Delete team?"
    override fun eventDeleteTeamMessage(teamName: String) = "\"$teamName\" will be removed from this event. Players assigned to it become unassigned."
    override val eventPlayersTitle = "Players"
    override fun eventApprovedCount(confirmed: Int, total: Int) = "($confirmed/$total Approved)"
    override val eventAwaitingPlayers = "Awaiting Players"
    override val eventAwaitingPlayersSubtitle = "Join the event now to start forming teams."
    override val eventAssignToTeam = "Assign to Team"
    override val eventFormatLabel = "Format:"
    override val eventProLabel = "Pro"
    override val eventTimeline = "Timeline"
    override val eventFormatAuto = "Auto"
    override val eventCoach = "Coach"
    override val eventSaving = "Saving..."
    override val eventCreating = "Creating..."
    override val eventSaveChanges = "Save Changes"
    override val eventCreateEvent = "Create Event"
    override val eventEditEventTitle = "Edit Event"
    override val eventErrorTitleRequired = "Title is required"
    override val eventErrorSportRequired = "Sport is required"
    override val eventErrorSportNameRequired = "Sport name is required"
    override val eventErrorFormatRequiredPro = "Format is required for Pro events"
    override val eventErrorStartTimeRequired = "Start time is required"
    override val eventErrorEndTimeRequired = "End time is required"
    override val eventErrorEndAfterStart = "End time must be after start time"
    override val eventErrorStartInPast = "Start time can't be in the past"
    override val eventErrorSelectAddress = "Select an address"
    override val eventErrorAddressCity = "Pick a valid address that includes a city"
    override val eventErrorCoverRequired = "Cover photo is required"
    override val eventErrorSignInEdit = "Please sign in to edit events"
    override val eventErrorSignInCreate = "Please sign in to create events"
    override val eventErrorUploadImage = "Failed to upload image"
    override val eventErrorSaveChanges = "Failed to save changes"
    override val eventErrorCreateEvent = "Failed to create event"
    override val eventAddressLabel = "Address"
    override val eventAddressPlaceholder = "Search for address..."
    override val eventTitleLabel = "Title"
    override val eventTitlePlaceholder = "e.g. Sunday Football Match"
    override val eventSportNameLabel = "Sport Name"
    override val eventSportNamePlaceholder = "Enter sport name"
    override val eventMaxPlayersLabel = "Max Players"
    override val eventMaxPlayersPlaceholder = "e.g. 20"
    override val eventDateLabel = "Date"
    override val eventTimeFromLabel = "From"
    override val eventTimeToLabel = "To"
    override val eventChooseOnMap = "Choose on map"
    override val eventConfirmLocation = "Confirm location"
    override val eventAddPhoto = "Add Photo"
    override val eventSportLabel = "Sport"
    override val eventLoading = "Loading..."
    override val eventSelectSportPlaceholder = "Select sport"
    override val eventCommunityLabel = "Community"
    override val eventCommunityNone = "None (Public)"
    override val eventUnnamedGroup = "Unnamed Group"
    override val eventFormatFieldLabel = "Format"
    override val eventSelectPlaceholder = "Select"
    override val eventCostLabel = "Cost"
    override val eventPrivateLabel = "Private"
    override val eventPrivateInfoDescription = "Manage your squad by manually approving join requests or removing participants."

    // wallet
    override val walletTopUpTitle = "Top Up Wallet"
    override val walletSelectAmount = "Select amount"
    override val walletOr = "or"
    override val walletCustomAmount = "Custom amount"
    override val walletEnterAmountPlaceholder = "Enter amount"
    override val walletProcessing = "Processing…"
    override val walletTopUpAction = "Top Up"

    // nav
    override val navDashboard = "Dashboard"
    override val navClients = "Clients"
    override val navChat = "Chat"
    override val navSchedule = "Schedule"
    override val navClubSettings = "Club Settings"
    override val navArena = "Arena"
    override val navFeed = "Feed"
    override val navPeople = "People"
    override val navProfile = "Profile"
    override val navStatistic = "Statistic"
    override val navTeam = "Team"
    override val navMedia = "Media"
    override val navWeek = "Week"
    override val navMonth = "Month"
    override val navYear = "Year"

    // modal
    override val modalDecline = "Decline"
    override val modalCompleteSession = "Complete Session"
    override val modalTimeAlt = "Time"
    override val modalPriceAlt = "Price"
    override val modalBookings = "Bookings"
    override val modalTotalSpent = "Total Spent"
    override val modalSendMessage = "Send Message"
    override val modalAddNote = "Add Note"
    override val modalAdminNotes = "Admin Notes"
    override val modalAdminNotesPrivacy = "Private - only visible to admins"
    override val modalWriteNotePlaceholder = "Write a note..."
    override val modalAdd = "Add"
    override val modalBookingHistory = "Booking History"
    override val modalNoBookingsYet = "No bookings yet"
    override val modalFieldFallback = "Field"
    override val modalStatusConfirmed = "Confirmed"
    override val modalStatusPending = "Pending"
    override val modalStatusCompleted = "Completed"
    override val modalStatusCancelled = "Cancelled"
    override val modalPaid = "Paid"
    override val modalUnpaid = "Unpaid"

    // feed
    override val feedClubBadge = "Club"
    override fun feedAddAllPhotos(count: Int) = "Add all $count photo(s)"
    override val feedUploadFailed = "Upload failed"
    override val feedCreatePostFailed = "Failed to create post"
    override val feedCreatePostTitle = "Create Post"
    override val feedChooseLayoutSubtitle = "Choose a Layout for Your Post"
    override val feedFileTooLarge = "File too large (max 50 MB)"
    override val feedChooseLayout = "Choose a Layout"
    override val feedCreating = "Creating..."
    override val feedAddPhoto = "Add Photo"
    override val feedCityLabel = "City"
    override val feedEnterCityPlaceholder = "Enter city name..."
    override val feedPostContentLabel = "Post Content"
    override val feedPostContentPlaceholder = "Write something about this post..."
    override val feedOptional = "(Optional)"
    override val feedPickPhotoFirst = "Pick a photo first"
    override val feedCreateStoryFailed = "Failed to create story"
    override val feedCreateStoriesTitle = "Create Stories"
    override val feedCreateStoriesSubtitle = "Create and share your moments"
    override val feedFileTooLargeStory = "File too large (max 30 MB)"
    override val feedDropContentHere = "Drop your content here"
    override val feedMaxStorySize = " max 30 MB"
    override val feedFollowingSection = "Following"
    override val feedFollowersSection = "Followers"
    override val feedSearching = "Searching…"
    override val feedNoResults = "No results"
    override val feedLoadingMore = "Loading more…"
    override val feedThisUser = "this user"
    override fun feedUnfollowTitle(name: String) = "Unfollow $name?"
    override val feedUnfollowSubtitle = "You can re-follow any time."
    override val feedUnfollow = "Unfollow"
    override fun feedRemoveTitle(name: String) = "Remove $name?"
    override val feedRemoveSubtitle = "They won't be notified, but will no longer see your posts."
    override val feedRemove = "Remove"
    override val feedFollow = "Follow"
    override val feedDeleted = "Deleted"
    override val feedNotFollowingTitle = "Not Following Anyone Yet"
    override val feedNotFollowingBody = "Follow players to see their latest match posts, highlights, and stories in your feed."
    override val feedNoFollowersTitle = "No Followers Yet"
    override val feedNoFollowersBody = "Share your match posts and stories to get noticed by the community."
    override val feedDiscoverPlayers = "Discover Players"

    // dropdown
    override val dropdownAllCities = "All cities"
    override val dropdownSelectedAlt = "Selected"

    // page
    override val pageScheduleTitle = "Schedule"
    override val pageScheduleComingSoon = "Schedule view coming soon"
    override val pageEventsSeoTitle = "Sports Events"
    override val pageEventsSeoDescription = "Browse and join sports events near you — football, tennis, basketball, padel and more. Create your own game and invite players on Arena."
    override val pageEventsTitle = "Events"
    override val pageCreateEvent = "Create Event"
    override val pageNoEventsYet = "No events yet"
    override val pageNotFoundTitle = "Oops, page not found"
    override val pageNotFoundBody = "Please check the page address for typos or return to the main arena."
    override val pageBackToArena = "Back to Arena"
    override val pageChatTitle = "Chat"
    override val pageLoading = "Loading..."
    override val pageSomethingWentWrong = "Something went wrong"
    override fun pageUnfollowTitle(name: String) = "Unfollow $name"
    override val pageRemoveFollowerTitle = "Remove follower?"
    override fun pageRemoveFollowerSubtitle(name: String) = "We won't notify $name about this change."
    override val pageFeedTitle = "Feed"
    override val pageFeedSeoDescription = "See what the Arena sports community is up to — match results, highlights and moments shared by players near you."
    override val pageNoPostsYet = "No posts yet"
    override val pageLoadingMore = "Loading more..."
    override val pagePeopleSeoTitle = "Find Players"
    override val pagePeopleSeoDescription = "Discover athletes near you, match with players of your level and team up for your next game on Arena."
    override val pagePeopleTitle = "People"
    override val pageSquadUpTitle = "Squad Up"
    override val pageSquadUpSubtitle = "Find partners, connect with players, and start the game."
    override val pagePeopleLoadFailed = "Couldn't load people"
    override val pagePeopleCaughtUpTitle = "You're all caught up for now"
    override val pagePeopleCaughtUpSubtitle = "Come back later for more players."
    override val pageRefresh = "Refresh"
    override val pageClientsTitle = "Clients"
    override fun pageClientsTotal(total: Int) = "$total total clients"
    override val pageActiveClients = "Active Clients"
    override val pageTotalBookings = "Total Bookings"
    override val pageTotalRevenue = "Total Revenue"
    override val pageStatusVip = "VIP"
    override val pageStatusActive = "Active"
    override val pageStatusDebtor = "Debtor"
    override val pageStatusAll = "All Status"
    override val pageStatusInactive = "Inactive"
    override val pageAddNewClient = "Add New Client"
    override val pageColName = "Name"
    override val pageColRevenue = "Revenue"
    override val pageColStatus = "Status"
    override val pageColLastVisit = "Last visit"
    override val pageColActions = "Actions"
    override val pageUnpaidSuffix = "unpaid"
    override val pagePrevious = "Previous"
    override val pagePageLabel = "Page"
    override val pageOfLabel = "of"
    override val pageBackToEvents = "Back to Events"
    override val pageResetTimerTitle = "Reset timer?"
    override val pageResetTimerMessage = "The match timer will be set back to 00:00. Tracked stats stay intact."
    override val pageResetTimerConfirm = "Reset"
    override val pageResetting = "Resetting..."
    override val pageEndMatchTitle = "End match?"
    override val pageEndMatchMessage = "The event will be marked as completed and scores will be locked in."
    override val pageEndMatchConfirm = "End match"
    override val pageEnding = "Ending..."
    override val pageAddMedia = "Add Media"
    override val pageBook = "Book"
    override val pageCourtRules = "Court Rules"
    override val pageNoCourtRules = "No court rules specified."
    override val pageLeaveReview = "Leave a Review"
    override val pageNoReviewsYet = "No reviews yet."
    override val pageSportFootball = "Football"
    override val pageSportBasketball = "Basketball"
    override val pageSportTennis = "Tennis"
    override val pageSportPadel = "Padel"
    override val pageClubFallback = "Club"
    override fun pageReviewExperienceTitle(sportName: String) = "How was your $sportName experience?"
    override val pageWriteReviewPlaceholder = "Write your review..."
    override val pagePosting = "Posting..."
    override val pagePostReview = "Post Review"
    override val pageLoadMore = "Load more"
    override val pageArenaSeoTitle = "Arena"
    override val pageArenaSeoDescription = "Your sports career at a glance — stats, ratings and achievements across football, tennis, basketball and more on Arena."
    override val pageEventsTab = "Events"
    override val pageClubsTab = "Clubs"
    override val pageFilterLocation = "Location"
    override val pageUnnamedCommunity = "Unnamed"
    override val pageFilterCommunity = "Community"
    override val pageFilterAll = "All"
    override val pageFilterCalendar = "Calendar"
    override val pageAddEvent = "Add Event"
    override val pageAddClub = "Add Club"
    override val pageMap = "Map"
    override val pageOwnTheArena = "OWN THE ARENA"
    override val pageArenaBannerSubtitle = "Your arena awaits. Book instantly — play confidently."
    override val pageLoadingMoreEvents = "Loading more events..."
    override val pageLoadingMoreClubs = "Loading more clubs..."
    override val pageNoClubsYet = "No clubs yet"
    override val pageClubsWillAppear = "Clubs will appear here"
    override val pageEventsMapTitle = "Events Map"
    override val pageClubsMapTitle = "Clubs Map"
    override val pageDeleteClub = "Delete club"
    override val pageAddBanner = "Add Banner"
    override val pageRulePlaceholder = "e.g. Sportwear required"
    override val pageAddRule = "Add Rule"
    override val pageEditServices = "Edit Services"
    override val pageManageServices = "Manage Services"
    override val pageAmenityParking = "Parking"
    override val pageAmenityCafe = "Cafe"
    override val pageAmenityWifi = "WiFi"
    override val pageAmenityReception = "Reception"
    override val pageAmenityShower = "Shower"
    override val pageAmenityFirstAid = "First aid"
    override val pageReviewsLabel = "Reviews:"
    override val pageAvgRatingLabel = "Avg Ratn:"
    override val pageReviewsPlaceholderNote = "Reviews will appear here after users provide feedback."
    override val pageClubComposePrompt = "What's happening at your club?"
    override val pageClubNoPostsHint = "Share a photo and a quick thought to keep the club active."
    override val pageComposePostTitle = "Compose Post"
    override val pagePostContentPlaceholder = "Post content..."
    override fun pageAddImageSlot(slot: Int) = "Add image $slot"
    override val pagePostAction = "Post"
    override val pageEditClubInfo = "Edit Club Info"
    override val pageClubNameLabel = "Club name"
    override val pageAddressLabel = "Address"
    override val pageSearchAddressPlaceholder = "Search for address"
    override val pageSaveChanges = "Save Changes"

    // account
    override val accountRequiredTitle = "Account Required"
    override val accountRequiredDescription = "This feature is for registered players only. Sign in with Google or Apple to continue."
    override val accountRequiredTermsPrefix = "By continuing you agree to our "
    override val accountRequiredTerms = "Terms"
    override val accountRequiredPrivacy = "Privacy"

    // avatar
    override val avatarGenTitle = "AI Avatar"
    override val avatarGenErrorFileType = "Only JPEG, PNG, and WebP files are allowed"
    override val avatarGenErrorFileSize = "File size must be under 30MB"
    override val avatarGenGenerating = "Generating…"
    override val avatarGenGenerate = "Generate"
    override fun avatarGenGenerateWithPrice(price: String) = "Generate · $price"
    override val avatarGenGeneratedLook = "Generated Look"
    override val avatarGenDropPhotoHere = "Drop your photo here"
    override val avatarGenMaxFileSize = "max 30 MB"
    override val avatarGenReadyToGenerate = "Ready to generate"
    override val avatarGenCustomPrompt = "Custom prompt"
    override val avatarGenPromptPlaceholder = "Add details to set the style ..."
    override val avatarGenInfoDefaultBehavior = "By default the AI will cut you out from the photo and place you on the card."
    override val avatarGenInfoPromptIntro = "In the prompt you can also ask to:"
    override val avatarGenInfoBulletZoom = "Zoom in or out the figure"
    override val avatarGenInfoBulletObject = "Add or remove an object (e.g. sunglasses, jersey, ball, hat)"
    override val avatarGenOptionalBadge = "(Optional)"

    // card
    override val cardLifeTitle = "Bring Your Card to Life"
    override val cardLifeSubtitle = "Create your visual identity"
    override val cardLifeMyStyles = "My styles"
    override val cardLifeSelectToGenerate = "Select to generate"
    override val cardLifeActiveCards = "Active profile cards"
    override val cardLifeDragToReorder = "Drag to reorder"
    override val cardLifeNoTemplates = "No card templates yet. Pick one up in the Card Shop."
    override val cardLifeCreatePhoto = "Create Photo"
    override val cardLifeDeleteCardTitle = "Delete card?"
    override val cardLifeDeleteCardMessage = "This removes the card from your gallery. The template stays in your styles."

    // wallet
    override val walletTitle = "My Wallet"
    override val walletCredits = "Credits"
    override val walletSignInToBuy = "Please sign in to buy credits."
    override fun walletCreditsAdded(amount: Int) = "$amount credits added to your wallet."
    override val walletPurchaseFailed = "Purchase failed. Try again."
    override fun walletBuyFor(price: String) = "Buy for $price"
    override val walletBackToPackages = "Back to packages"
    override val walletSelectedPack = "Selected Pack"
    override fun walletOneTimePurchase(currency: String) = "$currency · One-time purchase"
    override val walletCurrentBalance = "Current balance"
    override val walletNewBalance = "New balance"
    override val walletSecuredNote = "Secured · No recurring charges"
    override val walletPaymentMethod = "Payment Method"
    override val walletOrPayWithCard = "Or pay with card"
    override val walletCardNumber = "Card Number"
    override val walletExpiryDate = "Expiry Date"
    override val walletCvc = "CVC"
    override fun walletConfirmAndPay(price: String) = "Confirm & Pay €$price"

    // complete
    override val completeProfileTitle = "Complete your profile to start swiping"
    override val completeProfileDescription = "Complete your profile to see players who match your skill level and shared interests."
    override val completeProfileMaybeLater = "Maybe later"
    override val completeProfileAction = "Complete profile"

    // preference
    override val preferenceDetailsTitle = "Preference details"

    // follow
    override val followListFollowers = "Followers"
    override val followListFollowing = "Following"
    override val followListNoResults = "No results"
    override val followListNoFollowersYet = "No followers yet"
    override val followListNotFollowingAnyoneYet = "Not following anyone yet"
    override val followListUnfollow = "Unfollow"
    override val followListFollow = "Follow"
    override val followListRemove = "Remove"
    override val followListDeleted = "Deleted"

    // top
    override val topUpTitle = "Top up your wallet"
    override fun topUpNeedMessage(required: String, action: String, balance: String) = "You need $required to $action, but your wallet has $balance."
    override val topUpChooseAmount = "Choose amount"
    override val topUpOr = "or"
    override val topUpCustomAmount = "Custom amount"
    override val topUpEnterAmountPlaceholder = "Enter amount"
    override val topUpAction = "Top Up"
    override val topUpFailed = "Top-up failed"

    // interactions
    override val interactionsTitle = "Interactions"
    override fun interactionsSubtitle(newLikes: Int, matches: Int) = "$newLikes new likes · $matches matches"
    override val interactionsNewLikes = "New likes"
    override val interactionsNoNewLikesTitle = "No new likes yet"
    override val interactionsNoNewLikesMessage = "When someone swipes Yes on you they'll show up here."
    override val interactionsMatches = "Matches"
    override val interactionsNoMatchesTitle = "No matches yet"
    override val interactionsNoMatchesMessage = "Swipe Yes on someone who already liked you to lock in a match."

    // match
    override val matchItsWord = "It's"
    override val matchWord = "Match"
    override val matchSubtitle = "Time to connect and plan your game."
    override val matchKeepSwiping = "Keep Swiping"
    override val matchGoToProfile = "Go to Profile"
    override val matchYouFallback = "You"

    // purchase
    override val purchaseCardTitle = "Get this card?"
    override val purchaseCardBuying = "Buying…"
    override val purchaseCardBuyNow = "Buy now"

    // post
    override val postCommentsLike = "Like"
    override val postCommentsOneLike = "1 Like"
    override fun postCommentsLikes(count: Int) = "$count Likes"
    override val postCommentsInputPlaceholder = "Type a message…"

    // story
    override fun storySeenBy(count: Int) = "Seen by $count"

    // support
    override val supportTitle = "Contact Support"
    override val supportIntro = "Tell us what went wrong or what you need help with — we'll get back to you by email."
    override val supportEmailLabel = "Your email"
    override val supportMessageLabel = "Message"
    override val supportMessagePlaceholder = "Describe your issue…"
    override val supportErrorInvalidEmail = "Please enter a valid email."
    override val supportErrorEmptyMessage = "Please write a message."
    override val supportErrorGeneric = "Something went wrong. Please try again."
    override val supportSending = "Sending…"
    override val supportSendMessage = "Send message"
    override val supportSentTitle = "Message sent!"
    override val supportSentMessage = "Thanks for reaching out — we'll reply to your email soon."

    // person
    override val personDetailTabAbout = "About"
    override val personDetailTabPosts = "Posts"
    override val personDetailTabAchievement = "Achievement"
    override val personDetailAchievementsComingSoon = "Achievements coming soon."
    override val personDetailFollowing = "Following"
    override val personDetailFollowers = "Followers"
    override val personDetailSportLabel = "Sport:"
    override val personDetailActivityLabel = "Activity:"
    override val personDetailLifestyleLabel = "Lifestyle:"
    override val personDetailNoPostsTitle = "No Posts Yet"
    override val personDetailNoPostsMessage = "This player hasn't posted anything yet."

    // common
    override val commonClose = "Close"
    override val commonDone = "Done"
    override val commonLoading = "Loading…"
    override val commonBack = "Back"
    override val commonSkip = "Skip"

    // profile
    override val profileCardShopLoading = "Loading..."
    override val profileCardShopEmpty = "No cards available"
    override val profileCardShopBuy = "Buy"
    override val profileCardShopFree = "Free"
    override val profileFormationReservePlate = "Res"
    override val profileFormationCoach = "Coach"
    override val profileMediaEmpty = "No media yet"
    override val profileMediaImageAlt = "media"
    override val profileNewsPrompt = "What's on your mind?"
    override val profileNewsLoading = "Loading..."
    override val profileNewsLoginRequired = "Log in to see your posts"
    override val profileNewsEmpty = "No posts yet. Share something!"
    override val profileNewsPlaceholder = "Write something..."
    override val profileNewsPosting = "Posting..."
    override val profileNewsPost = "Post"
    override val profileRadarTitle = "Radar"
    override val profileRecentMatchesTitle = "Recent events"
    override val profileRecentMatchesEmptyTitle = "No events scheduled yet"
    override val profileRecentMatchesEmptyHint = "Pick an upcoming event and join the action!"
    override fun profileRecentMatchesSportPro(sport: String) = "$sport · Pro+"
    override val profileRecentMatchesTeamA = "Team A"
    override val profileRecentMatchesTeamB = "Team B"
    override fun profileRecentMatchesPeopleCount(count: Int) = "$count ppl"
    override val profileRecentMatchesWin = "Win"
    override val profileRecentMatchesLoss = "Loss"
    override val profileRecentMatchesDraw = "Draw"
    override val profileRecentMatchesSportFallback = "Sport"
    override val profileRecentMatchesProPlus = "Pro+"
    override fun profileRecentMatchesFormat(format: Int) = "$format X $format Format"
    override fun profileRecentMatchesMembers(count: Int) = "$count Members"
    override val profileShortcutStatistic = "Statistic"
    override val profileShortcutMedia = "Media"
    override val profileStatsChartsGoals = "Goals"
    override val profileStatsChartsAssists = "Assists"
    override val profileStatsChartsPerYear = "per year"
    override val profileStatsChartsPerWeek = "per week"
    override val profileStatsChartsPerMonth = "per month"
    override fun profileStatsChartsTitle(stat: String, period: String) = "$stat $period"
    override val profileStatsChartsNoData = "No data available"
    override val profileTeamEmptyOwnTitle = "You don't have a team yet"
    override val profileTeamEmptyOtherTitle = "No team"
    override val profileTeamEmptyCreateTeam = "Create Team"
    override val profileTrackerTitle = "Tracker"
    override val profileTrackerWorldMap = "World Map"
    override val profileTeamMatchesEmpty = "No matches yet"
    override val profileTeamMatchesUpcomingTitle = "Upcoming matches"
    override val profileTeamMatchesUpcomingEmpty = "No upcoming matches"
    override val profileTeamMatchesVenueAlt = "Venue"
    override fun profileTeamMatchesTeamsCount(count: Int) = "$count Teams"
    override fun profileTeamMatchesMembersCount(current: Int, total: Int) = "$current/$total Members"
    override fun profileTeamMatchesFormat(format: Int) = "${format}x${format} Format"
    override val profileTeamOverviewTitle = "Team Overview"
    override val profileTeamOverviewClubTitle = "Football Club"
    override val profileTeamOverviewRating = "Rating"
    override val profileTeamOverviewTeamRating = "Team Rating"
    override val profileTeamOverviewStatistics = "Statistics"
    override val profileTeamOverviewWins = "Wins"
    override val profileTeamOverviewDraws = "Draws"
    override val profileTeamOverviewLosses = "Losses"
    override val profileSidebarTitle = "Overview"
    override val profileSidebarFollowing = "Following"
    override val profileSidebarFollowers = "Followers"
    override val profileSidebarAchievement = "Achievement"
    override val profileSidebarAboutYouEmpty = "Add a few words about yourself to introduce your profile"
    override val profileSidebarFocusActivities = "Focus & Activities"
    override val profileSidebarSportLabel = "Sport"
    override val profileSidebarActivityLabel = "Activity"
    override val profileSidebarLifestyleLabel = "Lifestyle"
    override val profileSidebarChat = "Chat"
    override val profileSidebarFollow = "Follow"
    override val profileSidebarUnfollow = "Unfollow"
    override val profileSidebarNoInterests = "No interests added"
    override val profileSidebarNoInterestsBody = "Show others your hobbies and sports."
    override val profileHubTitle = "Player Hub"
    override val profileHubYourStories = "Your Stories"
    override val profileHubStories = "Stories"
    override val profileHubCardShopUnavailable = "Card shop unavailable"
    override val profileHubCardShopTitle = "Card Shop"
    override val profileHubCardShopSubtitle = "Buy new cards. Define your style."
    override val profileHubActiveBought = "Active & Bought"
    override fun profileHubOwnedCount(count: Int) = "$count owned"
    override val profileHubNoCardsYet = "No cards yet"
    override val profileHubAvailableForPurchase = "Available for purchase"
    override val profileHubNewDesignsRegularly = "New designs regularly"
    override val profileHubAllCardsOwned = "All cards owned"
    override fun profileHubChartTitle(stat: String, period: String) = "$stat per $period"
    override val profileHubNoChartsTitle = "No charts available"
    override val profileHubNoChartsBody = "Choose a specific sport in the header to see goals, assists, games and the rest of your stats."
    override val profileHubContentTitle = "Content"
    override val profileHubLoading = "Loading..."
    override val profileHubAddStory = "Add story"
    override val profileHubAddPost = "Add post"
    override val profileHubUserFallback = "user"
    override val profileHubNoPostsYet = "No posts yet"
    override val profileHubShareFirstMoment = "Share your first moment"
    override val profileHubPlayerNotPosted = "This player hasn't posted yet."
    override val profileOverviewTitle = "Player Overview"
    override val profileOverviewPlayerIdentify = "Player Identify"
    override val profileOverviewChat = "Chat"
    override val profileOverviewAiAvatar = "AI Avatar"
    override val profileOverviewGoals = "Goals"
    override val profileOverviewGoalsUnit = "goals"
    override val profileOverviewWins = "Wins"
    override val profileOverviewWinsUnit = "wins"
    override val profileOverviewDraws = "Draws"
    override val profileOverviewDrawsUnit = "draws"
    override val profileOverviewLosses = "Losses"
    override val profileOverviewLossesUnit = "losses"
    override val profileOverviewAchievements = "Achievements"
    override val profileOverviewNotFollowingAnyone = "Not following anyone yet"
    override val profileOverviewComingSoon = "Coming soon"
    override val profileAwardsEmpty = "No awards yet"
    override val awardWelcomeTitle = "Welcome Award"
    override val awardTermScorerFootball = "Top Scorer"
    override val awardTermAssistFootball = "Top Assistant"
    override val awardTermScorerBasketball = "Top Points"
    override val awardTermAssistBasketball = "Top Assists"
    override val awardTermScorerTennis = "Most Winners"
    override val awardTermAssistTennis = "Most Aces"
    override val awardTermScorerVolleyball = "Top Attacker"
    override val awardTermAssistVolleyball = "Top Assists"
    override val awardTermScorerPadel = "Most Winners"
    override val awardTermAssistPadel = "Most Smashes"
    override val awardTermScorerGeneric = "Top Scorer"
    override val awardTermAssistGeneric = "Top Assistant"
    override val awardRank1 = "1st place"
    override val awardRank2 = "2nd place"
    override val awardRank3 = "3rd place"
    override val profileOverviewAddPost = "Add post"
    override val profileOverviewWritePlaceholder = "Write something..."
    override val profileOverviewPost = "Post"
    override val profileOverviewLoading = "Loading..."
    override val profileOverviewLoginToSeePosts = "Log in to see posts"
    override val profileOverviewNoPostsYet = "No posts yet"
    override val profileWizardLetsGo = "Let's go !"
    override val profileWizardStepPersonalInfoTitle = "Personal Info"
    override val profileWizardStepPersonalInfoDescription = "Tell about yourself to get started."
    override val profileWizardStepFocusTitle = "Focus & Activities"
    override val profileWizardStepFocusDescription = "Choose your sports and lifestyle"
    override val profileWizardStepCardTitle = "Bring Your Card to Life"
    override val profileWizardStepCardDescription = "Create your visual identity"
    override fun profileWizardSelectedCount(count: Int) = "$count selected"
    override val profileWizardPublicInfo = "Public info"
    override val profileWizardMyStyles = "My styles"
    override val profileWizardSelectToGenerate = "Select to generate"
    override val profileWizardNoTemplates = "No card templates available yet."
    override val profileWizardActiveCards = "Active profile cards"
    override val profileWizardDragToReorder = "Drag to reorder"
    override fun profileWizardCardCount(count: Int) = "$count card${if (count == 1) "" else "s"}"
    override val profileWizardCreatePhoto = "Create Photo"
    override val profileFocusEditTitle = "Focus & Activities"
    override val profileFocusEditDescription = "Pick your sports and lifestyle to shape your identity."
    override val profileFocusEditSelectedLabel = "selected"
    override val profileFocusEditClearAll = "Clear All"
    override val profileFocusEditSearchPlaceholder = "Search attributes…"
    override val profileFocusEditSportLabel = "Sport"
    override val profileFocusEditActivityLabel = "Activity"
    override val profileFocusEditLifestyleLabel = "Lifestyle"
    override val profileFocusEditNoMatches = "No matches"
    override val profileFocusEditPreferenceDetails = "Preference details"
    override val profileFocusEditPreferenceHint = "Optional, but helps you find like-minded people faster."
    override val profileFocusEditNoteLabel = "Note"
    override val profileFocusEditNotePlaceholder = "What are you looking for?"
    override val profileFocusEditAddDetails = "Add details"
    override val profilePersonalEditTitle = "Personal Info"
    override val profilePersonalEditDescription = "Tell about yourself to get started."
    override val profilePersonalEditFirstNameLabel = "First name"
    override val profilePersonalEditLastNameLabel = "Last name"
    override val profilePersonalEditAboutMeLabel = "About me"
    override val profilePersonalEditBioPlaceholder = "Tell other players a bit about yourself…"
    override val profilePersonalEditDobLabel = "Date of birth"
    override val profilePersonalEditCityLabel = "City"
    override val profilePersonalEditCitySearchPlaceholder = "Search city…"
    override val profilePersonalEditLanguagesLabel = "Languages"
    override val profilePersonalEditTypeLanguagePlaceholder = "Type a language…"
    override val profilePersonalEditAddLanguagePlaceholder = "Add language…"
    override val profileEditSheetPublicInfo = "Public info"
    override val profileEditShellPublicInfo = "Public info"
    override fun profileCreatePostAddAllPhotos(count: Int) = "Add all $count photo(s)"
    override val profileCreatePostUploadFailed = "Upload failed"
    override val profileCreatePostCreateFailed = "Failed to create post"
    override val profileCreatePostTitle = "Create Post"
    override val profileCreatePostChooseLayout = "Choose a Layout"
    override val profileCreatePostFileTooLarge = "File too large (max 50 MB)"
    override val profileCreatePostCreating = "Creating..."
    override val profileCreatePostAddPhoto = "Add Photo"
    override val profileCreatePostContentLabel = "Post Content"
    override val profileCreatePostContentPlaceholder = "Write something about this post..."
    override val profileCreatePostCityLabel = "City"
    override val profileCreatePostCityPlaceholder = "Enter city name..."
    override val profileCreateStoryPickPhotoFirst = "Pick a photo first"
    override val profileCreateStoryUploadFailed = "Upload failed"
    override val profileCreateStoryCreateFailed = "Failed to create story"
    override val profileCreateStoryTitle = "Create Stories"
    override val profileCreateStorySubtitle = "Create and share your moments"
    override val profileCreateStoryFileTooLarge = "File too large (max 30 MB)"
    override val profileCreateStoryCreating = "Creating..."
    override val profileCreateStoryDropHere = "Drop your content here"
    override val profileCreateStoryMaxSize = " max 30 MB"
    override val profileFollowListFollowers = "Followers"
    override val profileFollowListFollowing = "Following"
    override val profileFollowListNoResults = "No results"
    override val profileFollowListUnfollow = "Unfollow"
    override val profileFollowListFollow = "Follow"
    override val profileFollowListRemoved = "Removed"
    override val profileFollowListRemove = "Remove"
    override val profileFollowListNotFollowingTitle = "Not Following Anyone Yet"
    override val profileFollowListNotFollowingBody = "Follow players to see their latest match posts, highlights, and stories in your feed."
    override val profileFollowListDiscoverPlayers = "Discover Players"
    override val profileFollowListNoFollowersTitle = "No Followers Yet"
    override val profileFollowListNoFollowersBody = "Share your match posts and stories to get noticed by the community."
    override val profileDialogPreferenceDetails = "Preference details"
    override val profileStoryViewersTitle = "Who saw this story?"
    override val profileStoryViewersNoViews = "No views yet"
    override val profileContentMobileOverview = "Overview"
    override val profileContentMobileFollowing = "Following"
    override val profileContentMobileFollowers = "Followers"
    override val profileContentMobileAwardsComingSoon = "Awards coming soon"
    override val profileContentMobileRecentEvents = "Recent events"
    override val profileContentMobileNoEvents = "No events scheduled yet"
    override val profileContentMobileNoEventsBody = "Pick an upcoming event and join the action!"
    override val profileContentMobileResultWin = "Win"
    override val profileContentMobileResultDraw = "Draw"
    override val profileContentMobileResultLoss = "Loss"
    override val profileContentMobileSportFallback = "Sport"
    override fun profileContentMobileFormat(format: Int) = "$format X $format Format"
    override fun profileContentMobileMembers(count: Int) = "$count Members"
    override val profileContentMobilePlayerHub = "Player Hub"
    override val profileContentMobileNoPostsTitle = "No Posts Yet"
    override val profileContentMobileNoPostsOwnBody = "Share match photos and highlights to fill your profile."
    override val profileContentMobileNoPostsOtherBody = "This player hasn't posted anything yet."
    override val profileContentMobileCardsUnavailable = "Cards unavailable"
    override val profileContentMobileCardsLoadFailed = "Failed to load cards"
    override val profileContentMobileNoCardsAvailable = "No cards available"
    override val profileContentMobileActiveBought = "Active & Bought"
    override fun profileContentMobileOwnedCount(count: Int) = "$count owned"
    override val profileContentMobileAvailableForPurchase = "Available for purchase"
    override val profileContentMobileNewDesigns = "New designs regularly"
    override val profileContentMobileNoCardsYet = "No cards yet"
    override val profileContentMobileCardsTitle = "Cards"
    override val profileContentMobileAddPost = "Add post"
    override val profileContentMobileUserFallback = "user"
    override val profileUserSheetError = "Something went wrong"
    override val profileUserSheetThisUser = "this user"
    override fun profileUserSheetUnfollowTitle(name: String) = "Unfollow $name?"
    override val profileUserSheetRefollowHint = "You can re-follow any time."
    override val profileUserSheetUnfollow = "Unfollow"

    // header
    override val headerNavHome = "Home"
    override val headerNavAbout = "About"
    override val headerNavServices = "Services"
    override val headerNavProjects = "Projects"
    override val headerNavContacts = "Contacts"
    override val headerSportLabel = "Sport:"
    override val headerUserFallbackName = "User"
    override val headerNoActiveEvents = "No active events or bookings"
    override val headerNoNotifications = "No notifications"
    override val headerYourActiveEvents = "Your Active Events "
    override val headerNotificationsTitle = "Notifications "
    override val headerMarkAllRead = "Mark all read"
    override val headerLoadMore = "Load more"
    override val headerPendingApproval = "Pending Approval"
    override val headerEventStatusNew = "New"
    override val headerEventStatusInProgress = "In Progress"
    override val headerEventStatusCompleted = "Completed"
    override val headerEventStatusCancelled = "Cancelled"
    override val headerBookingFallback = "Booking"
    override val headerActionView = "View"
    override val headerActionReply = "Reply"
    override val headerActionUnfollow = "Unfollow"
    override val headerActionFollowBack = "Follow Back"
    override val headerActionAccept = "Accept"
    override val headerActionDecline = "Decline"
    override val headerConfirmTitle = "Are you sure?"
    override val headerSignOutConfirmMessage = "You'll be signed out of Arena on this device. Your data stays safe."
    override val headerSignOutConfirmLabel = "Sign Out"
    override val headerDeleteConfirmMessage = "Deleting your profile is permanent. All credits, moments, and stats will be erased."
    override val headerDeleteConfirmLabel = "Confirm Deletion"
    override val headerDeleteProfileFailed = "Couldn't delete your profile. Please try again."
    override val headerUploading = "Uploading..."
    override val headerVisualStyle = "Visual Style"
    override val headerSyncWithSportType = "Sync with sport type"
    override val headerMyWallet = "My Wallet"
    override val headerSignOut = "Sign out"
    override val headerSigningOut = "Signing out..."
    override val headerDeleteProfile = "Delete Profile"
    override val headerRequestNoLongerAvailable = "This request is no longer available."
    override val headerRequestProcessFailed = "Couldn't process the request. Try again."
    override val headerSelectClub = "Select Club"
    override val headerAddClub = "Add Club"
    override val headerSwitchToPlayer = "Switch to Player"
    override val headerLogout = "Logout"
    override val headerLoggingOut = "Logging out..."
    override val headerSigningIn = "Signing in..."

    // home
    override val homeHeroBrand = "Arena Pro Play"
    override val homeHeroUnites = "unites"
    override val homeHeroAthletes = "athletes"
    override val homeHeroAndTeams = "and teams"
    override val homeHeroWorldwideFor = "worldwide for"
    override val homeSectionCreateEventsTitle = "Create Events"
    override val homeSectionCreateEventsHighlight = "Events"
    override val homeSectionCreateEventsSubtitle1 = "Choose the sport, set the schedule,"
    override val homeSectionCreateEventsSubtitle2 = "and add the game location."
    override val homeSectionTeammatesTitle = "Discover Perfect Teammates"
    override val homeSectionTeammatesHighlight = "Teammates"
    override val homeSectionMomentsTitle = "Share Moments, Connect with Friends"
    override val homeSectionMomentsHighlight = "Friends"
    override val homeSectionStatsTitle = "Track Stats, Evolution Progress & Customize Card"
    override val homeSectionStatsHighlight = "Progress"
    override val homeAltEventsScreen = "Events screen"
    override val homeAltCreateEventScreen = "Create event screen"
    override val homeAltCreateEventModal = "Create event modal"
    override val homeAltEventDetailScreen = "Event detail screen"
    override val homeAltDiscoverPeople = "Discover people"
    override val homeAltPlayerDiscoveryCard = "Player discovery card"
    override val homeAltMatchedInterests = "Matched interests"
    override val homeAltMatchedInterestsModal = "Matched interests modal"
    override val homeAltItsAMatch = "It's a match"
    override val homeAltFeedScreen = "Feed screen"
    override val homeAltFeedPost = "Feed post"
    override val homeAltGameMomentsPost = "Game moments post"
    override val homeAltChatScreen = "Chat screen"
    override val homeAltProfileOverview = "Profile overview"
    override val homeAltProfileDashboard = "Profile dashboard"
    override val homeAltPlayerStatsRadar = "Player stats radar"
    override val homeAltPlayerStatsCard = "Player stats card"
    override val homeAltRatePerformance = "Rate performance"
    override val homeAltRatePerformanceModal = "Rate performance modal"
    override val homeItsYourMatch = "It's your match!"
    override val homeLabelGameMoments = "Game Moments"
    override val homeLabelPlayerStats = "Player Stats"
    override val homeLabelRatePerformance = "Rate Performance"
    override val homeFooterTagline = "Your global sports community"
    override val homeFooterBlurb = "Find people nearby to play football, tennis, basketball, padel or volleyball — join pickup games and local sports events, or create your own on Arena."
    override val homeFooterAbout = "About"
    override val homeFooterTerms = "Terms of Service"
    override val homeFooterPrivacy = "Privacy Policy"
    override val homeFooterPricing = "Pricing"
    override val homeFooterRefund = "Refund Policy"
    override val homeFooterSupports = "Supports"
    override val homeFooterCopyright = "© 2026 Arena Pro Play"
    override val homeStoreAppleEyebrow = "DOWNLOAD ON THE"
    override val homeStoreAppleName = "Apple Store"
    override val homeStoreGoogleEyebrow = "GET IT ON"
    override val homeStoreGoogleName = "Google Play"

    // dashboard
    override val dashboardTabAnalytics = "Analytics"
    override val dashboardTabSchedule = "Schedule"
    override val dashboardRatingTitle = "Rating"
    override val dashboardReviews = "reviews"
    override val dashboardAvgDuration = "Avg Duration"
    override val dashboardTotalRevenue = "Total Revenue"
    override val dashboardTotalBookings = "Total Bookings"
    override val dashboardArenaSchedule = "Arena Schedule"
    override val dashboardThisWeek = "This Week"
    override val dashboardAddEvent = "Add Event"
    override val dashboardTimeHeader = "Time"
    override val dashboardCustomerFallback = "Customer"
    override val dashboardRevenueTitle = "Revenue"
    override val dashboardBookingsTitle = "Bookings"
    override val dashboardBookingStatusTitle = "Booking Status"
    override val dashboardBookingHeatmapTitle = "Booking Heatmap"
    override val dashboardDonutTotal = "Total"
    override val dashboardBookingsTooltipPrefix = "Bookings "
    override val dashboardStatusConfirmed = "Confirmed"
    override val dashboardStatusCompleted = "Completed"
    override val dashboardStatusPending = "Pending"
    override val dashboardStatusUnpaid = "Unpaid"
    override val dashboardStatusDeclined = "Declined"
    override val dashboardNoData = "No data"
    override val dashboardDayMon = "Mon"
    override val dashboardDayTue = "Tue"
    override val dashboardDayWed = "Wed"
    override val dashboardDayThu = "Thu"
    override val dashboardDayFri = "Fri"
    override val dashboardDaySat = "Sat"
    override val dashboardDaySun = "Sun"
    override fun dashboardHourLabel(hour: Int) = "${hour}h"
    override fun dashboardHeatmapTooltip(day: String, fromHour: Int, toHour: Int, count: Int) = "$day $fromHour:00–$toHour:00 · $count bookings"

    // arena
    override val arenaActionViewResults = "View Results"
    override val arenaActionWatchLive = "Watch Live"
    override val arenaActionJoinNow = "Join Now"
    override val arenaStatusLive = "Live"
    override val arenaStatusNew = "New"
    override val arenaStatusCompleted = "Completed"
    override val arenaStatusCanceled = "Canceled"
    override fun arenaMembersJoinedTotal(joined: Int, total: Int) = "$joined / $total Members"
    override fun arenaMembersCount(count: Int) = "$count Members"
    override fun arenaTeamsCount(count: Int) = "$count Teams"
    override fun arenaFormat(format: String) = "$format Format"
    override fun arenaFinalScore(score: String) = "Final Score $score"
    override fun arenaDuration(duration: String) = "Duration $duration"
    override val arenaLoadingClubs = "Loading clubs..."
    override val arenaLoadingMoreEvents = "Loading more events..."
    override val arenaLoadingMoreClubs = "Loading more clubs..."
    override val arenaLocationLabel = "Location: "
    override val arenaAllCities = "All cities"
    override val arenaCommunityAll = "All"
    override val arenaCommunityUnnamed = "Unnamed"
    override val arenaTabClubs = "Clubs"
    override val arenaTabEvents = "Events"
    override val arenaEmptyTitle = "No Events Scheduled Yet"
    override val arenaEmptySubtitle = "Create an event for match chat and real-time tracking."
    override val arenaAddEvent = "Add Event"
    override val arenaNoClubsTitle = "No clubs yet"
    override val arenaNoClubsSubtitle = "Clubs will appear here"

    // people
    override val peopleErrorLoad = "Couldn't load people"
    override val peopleCaughtUpTitle = "You're all caught up"
    override val peopleCaughtUpSubtitle = "Come back later for more players."
    override val peopleRefresh = "Refresh"
    override val peopleBadgeLike = "LIKE"
    override val peopleBadgeNope = "NOPE"
    override fun peopleNameAge(name: String, age: Int) = "$name, $age"

    // feed
    override val feedEmptyTitle = "Your Feed Is Empty"
    override val feedEmptySubtitle = "Follow players to see their posts and stories here."
    override val feedNoCommentsTitle = "No Comments Yet"
    override val feedNoCommentsSubtitle = "Be the first to comment."
    override val feedMessagePlaceholder = "Type a message..."
    override val feedLikeZero = "Like"
    override val feedLikeOne = "1 Like"
    override fun feedLikeMany(count: Int) = "$count Likes"

    // auth
    override val authWelcomeTitle = "Welcome to the Arena!"
    override val authWelcomeSubtitle = "Sign in with Google or Apple to create your profile, unlock this page, and start your sports journey with us."
    override val authAgreePrefix = "By continuing you agree to our"
    override val authTerms = "Terms"
    override val authPrivacy = "Privacy"

    // layout
    override val layoutComingSoon = "Coming Soon"
}
